export default "__VITE_ASSET__mOqXirbW__"